import React, { useState, useCallback, useEffect } from "react";
import AdminNavigation from "../AdminNavigation";
import Select from "../../../forms/Select";
import { validateField } from "../../../pages/functions";
import { addNotification as notify } from "reapop";
import { COUNTRIES, REF_DATA } from "../../../constants";
import connect from "react-redux/es/connect/connect";
import { getApplicationRegex } from "../../plugins/utils";
import { api_v2 } from "../../NewIndex.api";
import "./audit_styles.css";
import InputGroup from "../../../forms/InputGroup";
import moment from "moment";
import Datetime from "react-datetime";
import ReactSelect from "react-select";
import SpecialMessageModal from "./SpecialMessageModal";
import MessageModal from "../Content Management/MessageModal";
import PaginationOffsetLimit from "./PaginationOffsetLimit";

const V2_AuditHistory = (props) => {
  const pageSizeOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];
  const auditHistoryFields = {
    affiliate: {
      name: "Affiliate",
      value: null,
      rules: { title: "Affiliate" },
    },
    country: { name: "Country", value: null, rules: { title: "Country" } },
    userType: { name: "User Type", value: null, rules: { title: "User Type" } },
    language: { name: "Language", value: null, rules: { title: "Language" } },
    entity: {
      name: "Entity",
      value: "",
      rules: { title: "Entity", required: true },
    },
    startDate: {
      name: "startDate",
      value: "",
      rules: { title: "Start date UTC (YYYY-MM-DD)", required: true },
    },
    endDate: {
      name: "endDate",
      value: "",
      rules: { title: "End date UTC (YYYY-MM-DD)", required: true },
    },
  };

  const pageFilterFields = {
    pageSize: {
      name: "pageSize",
      value: "",
      rules: {
        title: "Items per page",
      },
    },
  };
  const entityOptions = [
    { value: "PRODUCT", label: "Product" },
    { value: "TET", label: "Temperature Excursion Tool (TET)" },
    { value: "TRANSLATIONS", label: "Translations" },
    { value: "CHATBOT", label: "Ami Chatbot" },
    { value: "MENU_CONFIGURATION", label: "Menu Configuration" },
    { value: "SITE_MESSAGES", label: "Site Messages" },
    { value: "CONGRESSES", label: "Congresses" },
  ];
  const userTypeOptions = [
    { value: "HCP", label: "HCP" },
    { value: "ABBVIE_EMPLOYEE", label: "Employee" },
    { value: "Patient", label: "Patient" },
  ];

  const [fields, setFields] = useState(auditHistoryFields);
  const [pageField, setPageField] = useState(pageFilterFields);
  const [countryOptions, setCountryOptions] = useState([]);
  const [affiliateOptions, setAffiliateOptions] = useState([]);
  const [languageOptions, setLanguageOptions] = useState([]);
  const [table, setTable] = useState([]);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [detailsMessage, setDetailsMessage] = useState("");
  const [detailsEntity, setDetailsEntity] = useState("");
  const [showNoDataFoundModal, setShowNoDataFoundModal] = useState(false);
  const [whichSelected, setWhichSelected] = useState("");
  const maxLength = 200;
  //pagination
  const [pageOffset, setPageOffset] = useState(0);
  const [pageLimit, setPageLimit] = useState(pageSizeOptions[0].value);
  const [totalCount, setTotalCount] = useState(0);
  const [changeEntity, setChangeEntity] = useState(false);

  const getLanguageList = useCallback(() => {
    const languageOptions = [];
    api_v2.fetchTETLanguage((JsonKeys) => {
      JsonKeys.forEach((languageList) => {
        languageOptions.push({
          value: languageList.language,
          label: languageList.language,
        });
      });
      setLanguageOptions(languageOptions);
    });
  }, []);

  const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  useEffect(() => {
    const countryList = props.referenceData.filter(
      (item) => item.type === COUNTRIES
    )[0].countries;
    const affiliateList = countryList
      .map((c) => c.affiliate)
      .filter(onlyUnique)
      .sort();
    const options = affiliateList.map((affiliate) => ({
      value: affiliate,
      label: affiliate,
    }));
    setAffiliateOptions(options);
    if (languageOptions.length === 0) {
      getLanguageList();
    }
  }, [props.referenceData, getLanguageList, languageOptions.length]);

  // Helper: check which fields to show for entity
  const getOptionalFieldsToRender = (entityValue) => {
    switch (entityValue) {
      case "TET":
        return {
          affiliate: true,
          country: true,
          userType: false,
          language: true,
        };
      case "TRANSLATIONS": {
        return {
          affiliate: false,
          country: true,
          userType: false,
          language: true,
        };
      }
      case "SITE_MESSAGES":
      case "CONGRESSES":
        return {
          affiliate: false,
          country: false,
          userType: false,
          language: false,
        };
      case "PRODUCT":
        return {
          affiliate: true,
          country: true,
          userType: false,
          language: false,
        };
      case "CHATBOT":
        return {
          affiliate: false,
          country: true,
          userType: true,
          language: true,
        };
      default:
        return {
          affiliate: true,
          country: true,
          userType: true,
          language: true,
        };
    }
  };

  const handleEntityChange = (selected) => {
    const entityValue = selected || "";
    setFields((prev) => ({
      ...prev,
      entity: { ...prev.entity, value: entityValue },
      affiliate: { ...prev.affiliate, value: null },
      country: { ...prev.country, value: null },
      userType: { ...prev.userType, value: null },
      language: { ...prev.language, value: null },
    }));
    setChangeEntity(true);
    setPageOffset(0);
    setTable([]);
    setWhichSelected("");
    const countryRefData = props.referenceData.filter(
      (item) => item.type === COUNTRIES
    )[0].countries;
    if (entityValue === "CHATBOT" || entityValue === "TRANSLATIONS") {
      setCountryOptions(
        countryRefData.map((item) => ({ value: item.name, label: item.name }))
      );
    } else {
      setCountryOptions([]);
    }
  };

  // Checkbox logic
  const onCheckboxChange = (type) => {
    setWhichSelected((prev) => (prev === type ? "" : type));
    setFields((prev) => ({
      ...prev,
      affiliate: { ...prev.affiliate, value: null },
      country: { ...prev.country, value: null },
      language: { ...prev.language, value: null },
      userType: { ...prev.userType, value: null },
    }));

    // Populate the countryOptions if COUNTRYWISE is selected (for PRODUCT or TET)
    if (
      type === "COUNTRYWISE" &&
      (fields.entity.value === "PRODUCT" || fields.entity.value === "TET")
    ) {
      const countryRefData = props.referenceData.filter(
        (item) => item.type === COUNTRIES
      )[0].countries;
      setCountryOptions(
        countryRefData.map((item) => ({ value: item.name, label: item.name }))
      );
    }
    if (type === "AFFILIATEWISE") {
      setCountryOptions([]);
    }
    if (type === "" || whichSelected === type) {
      setCountryOptions([]);
    }
  };

  // You may wish to also update handleAffiliateChange to clear other values if/when needed
  const handleAffiliateChange = (selected, currentEntity) => {
    setChangeEntity(true);
    setPageOffset(0);
    setFields((prev) => ({
      ...prev,
      affiliate: { ...prev.affiliate, value: selected },
      country: { ...prev.country, value: null },
    }));
    const countryRefData = props.referenceData.filter(
      (item) => item.type === COUNTRIES
    )[0].countries;
    if (currentEntity === "CHATBOT" || currentEntity === "TRANSLATIONS") {
      setCountryOptions(
        countryRefData.map((item) => ({ value: item.name, label: item.name }))
      );
    } else {
      let countryList = countryRefData.filter(
        (country) => country.affiliate === selected
      );
      setCountryOptions(
        countryList.map((item) => ({ value: item.name, label: item.name }))
      );
    }
  };

  const validate = useCallback((e, field) => {
    const inputValue = e.target.value.toLowerCase();
    const ref_Data = props.referenceData.find(function (category) {
      return category.type === REF_DATA;
    }).referenceData;
    const regex = getApplicationRegex(ref_Data);
    if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
      showNotification("Error!", "Special characters are not allowed", "error");
      return;
    }
    const validateFields = validateField(e, field, fields);
    setFields({ ...validateFields });
  }, []);

  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };

  const twoYearCutoff = moment().subtract(2, "year").subtract(1, "day");
  const futureCutoff = moment().endOf("day");

  const isValidStartDate = (date) => {
    if (!moment.isMoment(date)) return false;
    if (date.isBefore(twoYearCutoff) || date.isAfter(futureCutoff))
      return false;
    if (fields.endDate.value) {
      const end = moment(fields.endDate.value, "YYYY-MM-DD");
      if (date.isAfter(end)) return false;
      if (Math.abs(date.diff(end, "years")) >= 1) return false;
    }
    return true;
  };

  const isValidEndDate = (date) => {
    if (!moment.isMoment(date)) return false;
    if (date.isBefore(twoYearCutoff) || date.isAfter(futureCutoff))
      return false;
    if (fields.startDate.value) {
      const start = moment(fields.startDate.value, "YYYY-MM-DD");
      if (date.isBefore(start)) return false;
      if (Math.abs(date.diff(start, "years")) >= 1) return false;
    }
    return true;
  };

  const getPayload = () => ({
    entity: fields.entity.value,
    from: fields.startDate.value,
    to: fields.endDate.value,
    affiliate: fields.affiliate.value || "",
    country: fields.country.value || "",
    userType: fields.userType.value || "",
    language: fields.language.value || "",
    pageOffset, // Add offset
    pageLimit, // Add limit
  });

  // Existing logic for rendering optional fields
  const { affiliate, country, userType, language } = getOptionalFieldsToRender(
    fields.entity.value
  );

  const handleSearch = () => {
    const payload = getPayload();
    api_v2.getAuditHistory(payload, (res) => {
      if (res) {
        if (res.records && res.records.length > 0) {
          setTable(res.records);
          setTotalCount(res.totalCount || 0);
          setChangeEntity(false);
        } else {
          setTable([]);
          setShowNoDataFoundModal(true);
          setChangeEntity(false);
        }
      } else {
        showNotification("Error", "Please try again later!", "error");
        setTable([]);
        setShowNoDataFoundModal(false);
        setChangeEntity(false);
      }
    });
  };

  useEffect(() => {
    if (
      !changeEntity &&
      fields.entity.value &&
      fields.startDate.value &&
      fields.endDate.value
    ) {
      handleSearch();
    } else {
      setTable([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageOffset, pageLimit]);

  useEffect(() => {
    setPageField((prev) => ({
      ...prev,
      pageSize: { ...prev.pageSize, value: pageSizeOptions[0].value },
    }));
  }, []);

  const handlePageSizeChange = (option) => {
    setPageField((prev) => ({
      ...prev,
      pageSize: { ...prev.pageSize, value: option },
    }));
    setPageLimit(option);
    setPageOffset(0);
  };

  const handleDetails = (message, type) => {
    setOpenDetailsModal(true);
    setDetailsMessage(message);
    setDetailsEntity(type);
  };

  const handleExport = () => {
    const payload = getPayload();
    api_v2.exportAuditHistory(
      payload,
      (response) => {
        if (response.ok) {
          response.blob().then((blob) => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = "audit_history.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
            showNotification(
              "Success!",
              "Audit History exported successfully.",
              "success"
            );
          });
        } else {
          showNotification(
            "ERROR!",
            "Audit History exported has some problem, please try again after sometime..",
            "error"
          );
        }
      },
      () => {
        showNotification(
          "ERROR!",
          "Problem in Server, please try again after sometime..",
          "error"
        );
      }
    );
  };

  return (
    <div className="v2_container">
      <div className="row">
        {openDetailsModal && (
          <SpecialMessageModal
            type={detailsEntity}
            message={detailsMessage}
            isModalOpen={openDetailsModal}
            closeModal={() => {
              setOpenDetailsModal(false);
              setDetailsMessage("");
              setDetailsEntity("");
            }}
          />
        )}
        {showNoDataFoundModal && (
          <MessageModal
            message="No Data Found for this combination, try selecting other search criteria"
            isModalOpen={showNoDataFoundModal}
            closeModal={() => setShowNoDataFoundModal(false)}
          />
        )}
        <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
        <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
          <div className="row">
            <div className="col-12 col-xl-12">
              <h3 className="mb-3 header-primary">Audit History</h3>
              <p>
                <b>Select the entity type you want to view. </b> Based on the
                entity type, you will be able to see a list of optional fields.
              </p>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-4">
              <Select
                searchable
                clearable={false}
                options={entityOptions}
                field={fields.entity}
                validate={(e) => validate(e, fields.entity)}
                onChange={handleEntityChange}
              />
            </div>
          </div>

          {fields.entity.value.length > 0 &&
            fields.entity.value !== "SITE_MESSAGES" &&
            fields.entity.value !== "CONGRESSES" && (
              <div className="row">
                <p className="col-md-10">
                  <b>
                    Select the Affiliate or Country or User Type or Language you
                    want to view. (Optional)
                  </b>
                </p>
              </div>
            )}
          {/* --- New Checkbox Section Only for PRODUCT and TET --- */}
          {["PRODUCT", "TET"].includes(fields.entity.value) && (
            <div className="row mb-3">
              <div className="col-md-2">
                <input
                  type="radio"
                  name="filterType"
                  checked={whichSelected === "AFFILIATEWISE"}
                  onChange={() => onCheckboxChange("AFFILIATEWISE")}
                  id="affiliatewise-radio"
                  className="radio-large"
                  style={{ cursor: "pointer" }}
                />
                <label
                  htmlFor="affiliatewise-radio"
                  style={{
                    marginLeft: 8,
                    fontSize: "medium",
                    cursor: "pointer",
                  }}
                >
                  Select Affiliatewise
                </label>
              </div>
              <div className="col-md-2">
                <input
                  type="radio"
                  name="filterType"
                  checked={whichSelected === "COUNTRYWISE"}
                  onChange={() => onCheckboxChange("COUNTRYWISE")}
                  id="countrywise-radio"
                  className="radio-large"
                  style={{ cursor: "pointer" }}
                />
                <label
                  htmlFor="countrywise-radio"
                  style={{
                    marginLeft: 8,
                    fontSize: "medium",
                    cursor: "pointer",
                  }}
                >
                  Select Countrywise
                </label>
              </div>
            </div>
          )}

          {/* --- Conditional Dropdowns for PRODUCT & TET --- */}
          {fields.entity.value === "PRODUCT" && (
            <div className="row mb-3">
              {whichSelected === "COUNTRYWISE" && (
                <div className="col-md-3">
                  <ReactSelect
                    isSearchable
                    isClearable={true}
                    options={countryOptions}
                    value={
                      countryOptions.find(
                        (option) => option.value === fields.country.value
                      ) || null
                    }
                    onChange={(option) => {
                      setChangeEntity(true);
                      setPageOffset(0);
                      setFields((prev) => ({
                        ...prev,
                        country: {
                          ...prev.country,
                          value: option ? option.value : null,
                        },
                      }));
                    }}
                    placeholder="Select country"
                  />
                </div>
              )}
              {whichSelected === "AFFILIATEWISE" && (
                <div className="col-md-3">
                  <ReactSelect
                    isSearchable
                    isClearable={true}
                    options={affiliateOptions}
                    value={
                      affiliateOptions.find(
                        (option) => option.value === fields.affiliate.value
                      ) || null
                    }
                    onChange={(option) => {
                      setChangeEntity(true);
                      setPageOffset(0);
                      setFields((prev) => ({
                        ...prev,
                        affiliate: {
                          ...prev.affiliate,
                          value: option ? option.value : null,
                        },
                      }));
                    }}
                    placeholder="Select affiliate"
                  />
                </div>
              )}
            </div>
          )}

          {fields.entity.value === "TET" && (
            <div>
              {whichSelected === "COUNTRYWISE" && (
                <div className="row mb-3">
                  <div className="col-md-3">
                    <ReactSelect
                      isSearchable
                      isClearable={true}
                      options={countryOptions}
                      value={
                        countryOptions.find(
                          (option) => option.value === fields.country.value
                        ) || null
                      }
                      onChange={(option) => {
                        setChangeEntity(true);
                        setPageOffset(0);
                        setFields((prev) => ({
                          ...prev,
                          country: {
                            ...prev.country,
                            value: option ? option.value : null,
                          },
                        }));
                      }}
                      placeholder="Select country"
                    />
                  </div>
                  <div className="col-md-3">
                    <ReactSelect
                      isSearchable
                      isClearable={true}
                      options={languageOptions}
                      value={
                        languageOptions.find(
                          (option) => option.value === fields.language.value
                        ) || null
                      }
                      onChange={(option) => {
                        setChangeEntity(true);
                        setPageOffset(0);
                        setFields((prev) => ({
                          ...prev,
                          language: {
                            ...prev.language,
                            value: option ? option.value : null,
                          },
                        }));
                      }}
                      placeholder="Select language"
                    />
                  </div>
                </div>
              )}
              {whichSelected === "AFFILIATEWISE" && (
                <div className="row mb-3">
                  <div className="col-md-3">
                    <ReactSelect
                      isSearchable
                      isClearable={true}
                      options={affiliateOptions}
                      value={
                        affiliateOptions.find(
                          (option) => option.value === fields.affiliate.value
                        ) || null
                      }
                      onChange={(option) => {
                        setChangeEntity(true);
                        setPageOffset(0);
                        setFields((prev) => ({
                          ...prev,
                          affiliate: {
                            ...prev.affiliate,
                            value: option ? option.value : null,
                          },
                        }));
                      }}
                      placeholder="Select affiliate"
                    />
                  </div>
                </div>
              )}
            </div>
          )}

          {/* --- Default logic for all other entities --- */}
          {!(
            fields.entity.value === "PRODUCT" || fields.entity.value === "TET"
          ) &&
            fields.entity.value.length > 0 && (
              <div>
                <div className="row mb-3">
                  {affiliate && (
                    <div className="col-md-3">
                      <ReactSelect
                        isSearchable
                        isClearable={true}
                        options={affiliateOptions}
                        value={
                          affiliateOptions.find(
                            (option) => option.value === fields.affiliate.value
                          ) || null
                        }
                        onChange={(option) =>
                          handleAffiliateChange(
                            option ? option.value : null,
                            fields.entity.value
                          )
                        }
                        placeholder="Select affiliate"
                      />
                    </div>
                  )}
                  {country && (
                    <div className="col-md-3">
                      <ReactSelect
                        isSearchable
                        isClearable={true}
                        options={countryOptions}
                        value={
                          countryOptions.find(
                            (option) => option.value === fields.country.value
                          ) || null
                        }
                        onChange={(option) => {
                          setChangeEntity(true);
                          setPageOffset(0);
                          setFields((prev) => ({
                            ...prev,
                            country: {
                              ...prev.country,
                              value: option ? option.value : null,
                            },
                          }));
                        }}
                        placeholder="Select country"
                      />
                    </div>
                  )}
                  {userType && (
                    <div className="col-md-3">
                      <ReactSelect
                        isSearchable
                        isClearable={true}
                        options={userTypeOptions}
                        value={
                          userTypeOptions.find(
                            (option) => option.value === fields.userType.value
                          ) || null
                        }
                        onChange={(option) => {
                          setChangeEntity(true);
                          setPageOffset(0);
                          setFields((prev) => ({
                            ...prev,
                            userType: {
                              ...prev.userType,
                              value: option ? option.value : null,
                            },
                          }));
                        }}
                        placeholder="Select user type"
                      />
                    </div>
                  )}
                  {language && (
                    <div className="col-md-3">
                      <ReactSelect
                        isSearchable
                        isClearable={true}
                        options={languageOptions}
                        value={
                          languageOptions.find(
                            (option) => option.value === fields.language.value
                          ) || null
                        }
                        onChange={(option) => {
                          setChangeEntity(true);
                          setPageOffset(0);
                          setFields((prev) => ({
                            ...prev,
                            language: {
                              ...prev.language,
                              value: option ? option.value : null,
                            },
                          }));
                        }}
                        placeholder="Select language"
                      />
                    </div>
                  )}
                </div>
              </div>
            )}

          {/* Date selection and action buttons - unchanged */}
          <div className="row">
            <p className="col-md-8">
              <b>Select the start date and end date.</b>
            </p>
          </div>
          <div className="row mb-3">
            <div className="col-md-4">
              <Datetime
                closeOnSelect
                dateFormat="YYYY-MM-DD"
                timeFormat={false}
                renderInput={(_props, openCalendar, _closeCalendar) =>
                  getCalendarInputGroup(openCalendar, fields.startDate)
                }
                onChange={(date) => {
                  setChangeEntity(true);
                  setPageOffset(0);
                  const updatedFields = { ...fields };
                  updatedFields.startDate.value =
                    moment(date).format("YYYY-MM-DD");
                  setFields(updatedFields);
                  setTable([]);
                }}
                isValidDate={isValidStartDate}
              />
            </div>
            <div className="col-md-4">
              <Datetime
                closeOnSelect
                dateFormat="YYYY-MM-DD"
                timeFormat={false}
                renderInput={(_props, openCalendar, _closeCalendar) =>
                  getCalendarInputGroup(openCalendar, fields.endDate)
                }
                onChange={(date) => {
                  setChangeEntity(true);
                  setPageOffset(0);
                  const updatedFields = { ...fields };
                  updatedFields.endDate.value =
                    moment(date).format("YYYY-MM-DD");
                  setFields(updatedFields);
                  setTable([]);
                }}
                isValidDate={isValidEndDate}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-auto">
              <button
                className="btn btn-lg btn-info btn-rounded save_button"
                style={{ marginTop: "10px" }}
                onClick={handleSearch}
                disabled={
                  fields.entity.value === "" ||
                  fields.startDate.value === "" ||
                  fields.endDate.value === ""
                }
              >
                Search
              </button>
            </div>
            <div className="col-auto ms-2">
              <button
                className="btn btn-lg btn-success btn-rounded"
                style={{ marginTop: "10px" }}
                onClick={handleExport}
                disabled={
                  fields.entity.value === "" ||
                  fields.startDate.value === "" ||
                  fields.endDate.value === ""
                }
              >
                Export
              </button>
            </div>
          </div>
          {table.length > 0 && (
            <div className="row" style={{ overflowX: "scroll" }}>
              <div
                className="row mt-3"
                style={{ justifyContent: "space-between", width: "100%" }}
              >
                <div
                  className="col-md-8"
                  style={{ fontWeight: "bold", fontSize: "large" }}
                >
                  <i>{`Total Items: ${totalCount}`}</i>
                </div>
                <div className="col-md-1" style={{ marginBottom: "10px" }}>
                  <Select
                    searchable
                    clearable={false}
                    options={pageSizeOptions}
                    field={pageField.pageSize}
                    validate={(e) => {
                      return true;
                    }}
                    onChange={handlePageSizeChange}
                  />
                </div>
              </div>
              <table className="custom-table-audit-history">
                <thead>
                  <tr>
                    <th
                      style={{
                        textAlign: "center",
                        border: "1px solid #fff",
                      }}
                    >
                      Entity Name
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        border: "1px solid #fff",
                      }}
                    >
                      Affiliate
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        border: "1px solid #fff",
                      }}
                    >
                      Country
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        border: "1px solid #fff",
                      }}
                    >
                      User Type
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        border: "1px solid #fff",
                      }}
                    >
                      Language
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        border: "1px solid #fff",
                      }}
                    >
                      Type of Operation
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        border: "1px solid #fff",
                      }}
                    >
                      Details
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        border: "1px solid #fff",
                      }}
                    >
                      Created By
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        border: "1px solid #fff",
                      }}
                    >
                      Created On
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {table.map((entry, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          fontSize: "medium",
                          fontStyle: "inherit",
                          border: "1px solid #fff",
                        }}
                      >
                        {entry.entity || ""}
                      </td>
                      <td
                        style={{
                          fontSize: "medium",
                          fontStyle: "inherit",
                          border: "1px solid #fff",
                        }}
                      >
                        {entry.affiliate || ""}
                      </td>
                      <td
                        style={{
                          fontSize: "medium",
                          fontStyle: "inherit",
                          border: "1px solid #fff",
                        }}
                      >
                        {entry.country || ""}
                      </td>
                      <td
                        style={{
                          fontSize: "medium",
                          fontStyle: "inherit",
                          border: "1px solid #fff",
                        }}
                      >
                        {entry.userType || ""}
                      </td>
                      <td
                        style={{
                          fontSize: "medium",
                          fontStyle: "inherit",
                          border: "1px solid #fff",
                        }}
                      >
                        {entry.language || ""}
                      </td>
                      <td
                        style={{
                          fontSize: "medium",
                          fontStyle: "inherit",
                          border: "1px solid #fff",
                        }}
                      >
                        {entry.operation || ""}
                      </td>
                      <td
                        style={{
                          fontSize: "medium",
                          fontStyle: "inherit",
                          border: "1px solid #fff",
                        }}
                      >
                        {entry.details.length > maxLength ? (
                          <p>
                            {entry.details.substring(0, maxLength)}
                            <span
                              style={{ color: "#2f9ece", cursor: "pointer" }}
                              onClick={() =>
                                handleDetails(entry.details, entry.entity)
                              }
                            >
                              ..Read More
                            </span>
                          </p>
                        ) : (
                          entry.details || ""
                        )}
                      </td>
                      <td
                        style={{
                          fontSize: "medium",
                          fontStyle: "inherit",
                          border: "1px solid #fff",
                        }}
                      >
                        {entry.user || ""}
                      </td>
                      <td
                        style={{
                          fontSize: "medium",
                          fontStyle: "inherit",
                          border: "1px solid #fff",
                        }}
                      >
                        {entry.modifiedTime || ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {table.length > 0 && (
            <div className="row">
              <PaginationOffsetLimit
                pageOffset={pageOffset}
                pageLimit={pageLimit}
                totalCount={totalCount}
                setPageOffset={setPageOffset}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const getCalendarInputGroup = (openCalendar, field) => (
  <InputGroup
    searchable={false}
    clearable={false}
    field={field}
    validate={() => true}
    onFocus={openCalendar}
    readonly
  />
);

function mapStateToProps(state) {
  return {
    referenceData: state.referenceData,
  };
}

export default connect(mapStateToProps, { notify })(V2_AuditHistory);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/V2Audit/V2_AuditHistory.js